import { useTranslation } from "react-i18next";
import { WebEditPageShell } from "./WebEditPageShell";
import { EditProjectsContent } from "./forms/EditProjectsContent";

export default function EditProjectsScreen() {
  const { t } = useTranslation("seeker");
  return (
    <WebEditPageShell title={t("cv.edit.projects")}>
      <EditProjectsContent />
    </WebEditPageShell>
  );
}
